/* Engineer tour — 9 steps. BESS Designer-centric. */
export default {
  role: "ENGINEER",
  steps: [
    {
      id: "eng-welcome",
      route: "/",
      selector: '[data-tour-id="topbar-profile"]',
      titleKey: "tour.eng.welcome.title", titleFallback: "Welcome, {name}",
      bodyKey: "tour.eng.welcome.body", bodyFallback: "Tour focuses on the Designer + spec workflow. ~4 minutes.",
      side: "bottom",
    },
    {
      id: "eng-service-hint",
      route: "/",
      selector: '[data-tour-id="sidebar-nav-service"]',
      titleKey: "tour.eng.service.title", titleFallback: "Service tickets",
      bodyKey: "tour.eng.service.body", bodyFallback: "Field-service tickets land here. Currently P4 — coming next phase.",
      side: "right",
      optional: true,
    },
    {
      id: "eng-designer-open",
      route: "/sales/configurator/advanced",
      selector: '[data-tour-id="advanced-designer"]',
      titleKey: "tour.eng.designer.title", titleFallback: "Advanced Designer",
      bodyKey: "tour.eng.designer.body", bodyFallback: "Three steps — Application → Demand → Results — with live recompute. The math engine is the canonical sizing source of truth.",
      side: "top",
    },
    {
      id: "eng-step-1",
      route: "/sales/configurator/advanced",
      selector: '[data-tour-id="designer-step-1"]',
      titleKey: "tour.eng.step1.title", titleFallback: "Step 1 — Application",
      bodyKey: "tour.eng.step1.body", bodyFallback: "Pick use-case (Residential / C&I / Off-grid / Grid / EV). Drives default chemistry & PCS tier.",
      side: "right",
      optional: true,
    },
    {
      id: "eng-step-2",
      route: "/sales/configurator/advanced",
      selector: '[data-tour-id="designer-step-2"]',
      titleKey: "tour.eng.step2.title", titleFallback: "Step 2 — Demand",
      bodyKey: "tour.eng.step2.body", bodyFallback: "Daily energy + peak load + autonomy hours. The engine sizes the pack and PCS together.",
      side: "right",
      optional: true,
    },
    {
      id: "eng-step-3",
      route: "/sales/configurator/advanced",
      selector: '[data-tour-id="designer-step-3"]',
      titleKey: "tour.eng.step3.title", titleFallback: "Step 3 — Results",
      bodyKey: "tour.eng.step3.body", bodyFallback: "Headline numbers, BOM, payback. Click 'Save Design' → original_bom locked forever.",
      side: "left",
      optional: true,
    },
    {
      id: "eng-spec-pdf",
      route: "/sales/designer/designs",
      selector: '[data-tour-id="designs-list-page"]',
      titleKey: "tour.eng.spec.title", titleFallback: "Download Spec PDF",
      bodyKey: "tour.eng.spec.body", bodyFallback: "Each saved design ships a Weasyprint PDF with engineering grade tables.",
      side: "top",
    },
    {
      id: "eng-compare",
      route: "/sales/designer/designs",
      selector: '[data-tour-id="designs-list-page"]',
      titleKey: "tour.eng.compare.title", titleFallback: "Compare designs",
      bodyKey: "tour.eng.compare.body", bodyFallback: "Tick 2-3 rows → 'Compare' button → side-by-side diff with Δ markers on diverging metrics.",
      side: "top",
    },
    {
      id: "eng-replay",
      route: "/",
      selector: '[data-tour-id="tour-button"]',
      titleKey: "tour.eng.replay.title", titleFallback: "Replay anytime",
      bodyKey: "tour.eng.replay.body", bodyFallback: "Header button. Hit it whenever you want to retrace.",
      side: "bottom",
    },
  ],
};
